export default {
  specialModelTestList: state => state.specialModelTestList,
}
